import { j as json } from "../../../../../../chunks/index2.js";
import admin from "firebase-admin";
import { h as handleRequest } from "../../../../../../chunks/utils.js";
import { d as delay } from "../../../../../../chunks/utils2.js";
const getAllUsers = async (users = [], pageToken) => {
  const results = await admin.auth().listUsers(1e3, pageToken);
  const currentUsers = [...users, ...results.users];
  if (results.pageToken) {
    return getAllUsers(currentUsers, results.pageToken);
  } else {
    return currentUsers;
  }
};
const purgeUser = (user) => admin.auth().deleteUser(user.uid);
const GET = handleRequest(async () => {
  const users = await getAllUsers();
  for await (const user of users) {
    await purgeUser(user);
    await delay(100);
    console.log("Deleted user: ", user.uid);
  }
  return json({
    success: true
  });
});
export {
  GET
};
